
<div class="m-1 mt-2">
  <app-course-catalogue-search
    [feature]="feature"
    (shouldAddTrainingItemAsCourseButtonDisplayed)="showOrHideAddButton($event)"
    (emitSelectedData)="onSelectionOrDeselection($event)"
    [enableCheckBoxes]="showCheckBoxes"
    [panelListScreen]="panelListScreen"
  ></app-course-catalogue-search>
</div>
<div class="col mb-2 card flex" *ngIf="showAddButton">
  <p-splitButton
    class="p-splitbutton-menubutton splitBtn"
    label="Add and Close"
    (onClick)="addTrainingPlanAndClose()"
    [model]="items"
  ></p-splitButton>
</div>
